import useIntl from '@/utils/intl'
import React, { FunctionComponent, useState } from 'react'
import { Obj } from '..'
import { Checkbox, FormControlLabel } from '@mui/material'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { CheckCircle, RadioButtonUncheckedOutlined } from '@mui/icons-material'
import { useTheme } from '@/context/ThemeContext'

interface Props {
  onClick: (obj: Obj) => void
}

const Verification: FunctionComponent<Props> = ({ onClick }) => {
  const { translate } = useIntl()
  const [checkbox1Checked, setCheckbox1Checked] = useState<boolean>(false)
  const [checkbox2Checked, setCheckbox2Checked] = useState<boolean>(false)

  const { theme } = useTheme()

  const handleNext = (): void => {
    const obj: Obj = {
      choosenPackage: checkbox1Checked ? 'option1' : 'option2'
    }
    onClick(obj)
  }

  const handleCheckbox1Change = (): void => {
    setCheckbox1Checked(true)
    setCheckbox2Checked(false)
  }

  const handleCheckbox2Change = (): void => {
    setCheckbox2Checked(true)
    setCheckbox1Checked(false)
  }

  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start relative no-scrollbar'>
      <div className='flex-grow px-4 py-4 sm:px-8 sm:py-8 overflow-auto no-scrollbar flex flex-col gap-4'>
        <div
          className={`w-full px-4 py-3 flex justify-between items-center border bg-surfaceInverse rounded-xl cursor-pointer 
        ${
          checkbox1Checked
            ? 'border-primaryMainStroke'
            : 'hover:border-primaryMainStroke'
        }`}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={checkbox1Checked}
                onChange={handleCheckbox1Change}
                name='checkbox1'
                icon={
                  <RadioButtonUncheckedOutlined
                    sx={{
                      color: theme === 'dark' ? '#FFFFFF' : 'text.primary'
                    }}
                  />
                }
                checkedIcon={
                  <CheckCircle sx={{ color: 'rgba(239, 62, 62, 1)' }} />
                }
                className='ml-2 mr-2 p-0'
              />
            }
            label={
              <div className='flex flex-col items-start'>
                <span className='text-base text-textHigh font-bold'>
                  {translate('leasing.step1TextTitle')}
                </span>
                <span className='text-sm text-textLow'>
                  {translate('leasing.step1TextDesc')}
                </span>
              </div>
            }
            className='flex-grow'
          />
        </div>

        <div
          className={`w-full px-4 py-3 flex justify-between items-center border bg-surfaceInverse rounded-xl cursor-pointer 
        ${
          checkbox2Checked
            ? 'border-primaryMainStroke'
            : 'hover:border-primaryMainStroke'
        }`}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={checkbox2Checked}
                onChange={handleCheckbox2Change}
                name='checkbox2'
                icon={
                  <RadioButtonUncheckedOutlined
                    sx={{
                      color: theme === 'dark' ? '#FFFFFF' : 'text.primary'
                    }}
                  />
                }
                checkedIcon={
                  <CheckCircle sx={{ color: 'rgba(239, 62, 62, 1)' }} />
                }
                className='ml-2 mr-2 p-0'
              />
            }
            label={
              <div className='flex flex-col items-start'>
                <span className='text-base text-textHigh font-bold'>
                  {translate('leasing.step1TextTitle2')}
                </span>
                <span className='text-sm text-textLow '>
                  {translate('leasing.step1TextDesc2')}
                </span>
              </div>
            }
            className='flex-grow'
          />
        </div>
      </div>
      <div className='fixed md:sticky bottom-0 rounded-b-xl right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <div className='md:w-96 w-full' />
        <DarkButton
          size='sm'
          fullwidth
          disabled={!(checkbox1Checked || checkbox2Checked)}
          onClick={handleNext}
        >
          {translate('continue')}
        </DarkButton>
      </div>
    </div>
  )
}

export default Verification
